module.exports = __webpack_public_path__ + "static/media/noclass13.cc1af35e.png";